<template>
  <v-card class="pa-3 pt-2" outlined rounded>
    <span>Filtros</span>
    <div class="d-flex align-center flex-wrap gap-2">
      <ReportDateFilter v-model="filters" />
      <ReportChannelFilter v-model="filters" />
      <ReportTicketBlockFilter
        v-model="filters"
        :ticket-groups="ticketGroups || []"
      />
      <v-chip
        :color="!filters?.hideCourtesy ? 'primary' : 'secondary'"
        @click="filters.hideCourtesy = !filters?.hideCourtesy"
        :input-value="!filters?.hideCourtesy"
        filter
        small
      >
        Mostrar cortesias
      </v-chip>
    </div>
  </v-card>
</template>

<script>
const defaultFilters = {
  startDate: null,
  endDate: null,
  hideCourtesy: false,
  ticketBlocks: [],
  channel: ["pos", "site", "promoter"],
};

import ReportDateFilter from "./ReportDateFilter.vue";
import ReportChannelFilter from "./ReportChannelFilter.vue";
import ReportTicketBlockFilter from "./ReportTicketBlockFilter.vue";

export default {
  name: "ReportFilters",
  components: {
    ReportDateFilter,
    ReportChannelFilter,
    ReportTicketBlockFilter,
  },
  props: {
    value: {
      type: Object,
      default: () => ({ ...defaultFilters }),
    },
    ticketGroups: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    filters: {
      get() {
        return this.value || { ...defaultFilters };
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  mounted() {
    if (!this.value) {
      this.filters = { ...defaultFilters };
    }
    // this.filters.ticketBlocks = this.ticketGroups.map(({ TicketBlock }) =>
    //   TicketBlock.map(({ id }) => id)
    // );
  },
};
</script>
